import moment from "moment";

// Parser utils
const getIdentifierFromTitle = title => {
  if (!title) return null;
  // Allow letters, numbers, '-' and '_' and remove everything else
  let id = title.toLowerCase().replace(/[^a-z0-9-_]/g, "");
  // Do not allow '-' or '_' as the first or last character
  id = id.replace(/^[-_]+|[-_]+$/g, "");
  return id ? id + `_${moment().format("YYYYMMDD-HHmmss")}` : null;
};

// DataPortal
export const getDataPortalDatasetFromDataset = (dataset, language) => ({
  Identifier: getIdentifierFromTitle(dataset.title),
  Names: {[language]: dataset.title},
  Descriptions: {[language]: dataset.description},
  Source: dataset.organization,
  Themes: dataset?.theme ? [dataset?.theme] : [],
  Keywords: {[language]: dataset?.keywords || []},
  LastUpdate: moment().toISOStringNoOffset() + "+00:00",
  License: dataset.license,
  AccrualPeriodicity: "UNKNOWN",
  Public: true
});

export const getDataPortalResourceFromResource = (resource, language) => ({
  Url: resource.url || "@__file__0",
  Format: (resource.format || "").toUpperCase(),
  Names: {[language]: resource.title},
  Descriptions: {[language]: resource.title},
  Packages: [resource.packageId],
  LastUpdate: moment().toISOStringNoOffset() + "+00:00",
  License: resource.license,
  Public: true
});

// Ckan
export const getCkanDatasetFromDataset = dataset => ({
  Identifier: getIdentifierFromTitle(dataset.title),
  Name: getIdentifierFromTitle(dataset.title),
  Title: dataset.title,
  Notes: dataset.description,
  Groups: (dataset?.theme || []).length > 0 ? [dataset.theme[0]] : undefined,
  OwnerOrg: dataset.organization,
  Tags: (dataset?.keywords || []).map(keyword => ({Name: keyword})),
  Modified: moment().toISOStringNoOffset(),
  Frequency: "UNKNOWN"
});

export const getCkanResourceFromResource = resource => ({
  PackageId: resource.packageId,
  Name: resource.title,
  Format: resource.format,
  Description: "",
  LicenseType: "",
  Url: resource.url
});
